import { css } from "@emotion/css";
import DoneIcon from "@mui/icons-material/Done";
import {
  Autocomplete,
  Box,
  Chip,
  CircularProgress,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { ReactComponent as ErrorIcon } from "../../assets/images/ralvie/error-icon.svg";
import { ReactComponent as CancelIcon } from "../../assets/images/ralvie/Close.svg";
import { ReactComponent as TagInactiveIcon } from "../../assets/images/ralvie/tag-icon-inactive.svg";
import CustomButton from "../../components/CustomButton";
import CustomSwitch from "../../components/CustomSwitch";
import CustomTextField from "../../components/DescriptionBox";
import { addManualEvents } from "../../services/EventService";
import { findProjectsByAssignedMember } from "../../services/ProjectService";
import CommonUtil from "../../util/CommonUtils";
import { sidebarContext, TimesheetContext } from "../../util/context";
import { TimePicker } from "antd";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import {
  createTimesheet,
  createTimesheetManual,
} from "../../services/WorklogService";
import { getTagByName, createTagWithProject } from "../../services/TagService";
import "./AddEvents.scss";
import dayjs from "dayjs";
import CancelDialog from "../project/CancelDialog";
import AppContext from "../../config/AppContext";
import { useNavigate } from "react-router-dom";
import { ReactComponent as EmptyProjectList } from "../../assets/images/ralvie/noProjects.svg";
import { ReactComponent as EmptyProjectListDark } from "../../assets/images/ralvie/noProjectsDark.svg";
import UpgradePopup from "../../components/subscription-component/UpgradePopup";
import RestrictPermissionPopup from "../../components/subscription-component/RestrictPermissionPopup";
import { getTasksByProjectId } from "../../services/TaskService";
import CustomTypography from "../../components/CustomTypography";
import TaskPopup from "./TaskPopup";
import ProjectTagTextField from "../project/ProjectTagfield";
import TagworkField from "../worklog/TagworklogField";
import { getSubscriptionLimit } from "../../services/Subscription";



export default function AddEvents({ onClose, selectedDate, setIsLogged, isLogged }) {
  const { t } = useTranslation();
  const [projects, setProjects] = useState([]);
  const { mode } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(false);
  const [totalEventsDuration, setTotalEventsDuration] = useState(null);
  const [totalEventsDurationInSec, setTotalEventsDurationInSec] = useState(0);
  const [selectedEvents, setSelectedEvents] = useState([]);
  const { setEventsToLog, setReload } = useContext(TimesheetContext);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [tagError, setTagError] = useState(false);
  const [isDataChanged, setIsDataChanged] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [tagData, setTagData] = useState([]);
  const [showEndTimeError, setShowEndTimeError] = useState(false);
  const [showStartTimeError, setShowStartTimeError] = useState(false);
  const [showTimeError, setShowTimeError] = useState(false);
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
  const [zeroProjectCount, setZeroProjectCount] = useState(false);
  const navigate = useNavigate();
  const [upgradePopupOpen, setUpgradePopupOpen] = useState(false);
  const [restrictPopupOpen, setRestrictPopupOpen] = useState(false);
  const { subscriptionDetails } = useContext(sidebarContext);
  const [taskList, setTaskList] = useState([]);
  const [taskId, setTaskId] = useState("");
  const [isCreatingTag, setIsCreatingTag] = useState(false);
  const [isCreatingTask, setIsCreatingTask] = useState(false);
  const [isTaskPopupOpen, setIsTaskPopupOpen] = useState(false);
  const [showTagInput, setShowTagInput] = useState(false);
  const featureCode = "PROJECT_COUNT";
  const [isLimitLoading, setIsLimitLoading] = useState(true);
  const [totalProjectsCount, setTotalProjectsCount] = useState([]);
  const [currentProjectsCount, setCurrentProjectsCount] = useState([]);

  const [state, setState] = useState({
    source: "MANUAL",
    userId: "",
    windowTitle: "",
    projectId: "",
    tags: [],
    description: "",
    startTime: "",
    endTime: "",
    loggedDuration: 0,
    eventDuration: 0,
    events: [],
    hrs: 0,
    mins: 0,
    billable: true,
  });

  const [error, setError] = useState({
    windowTitle: "",
    projectId: "",
    tags: "",
    description: "",
    duration: "",
    loggedDuration: "",
    eventDuration: "",
    events: "",
    startTime: "",
    endTime: "",
    taskId: ""
  });
  const commonComponentsProps = (mode) => ({
    popper: {
      modifiers: [
        {
          name: "preventOverflow",
          options: {
            boundary: "viewport",
          },
        },
      ],
    },
    paper: {
      sx: {
        "& .MuiAutocomplete-listbox .MuiAutocomplete-option": {
          "&:hover": {
            backgroundColor: mode === "dark" ? "#362C20" : "#FFF9F2",
          },
          "&.Mui-selected": {
            backgroundColor: mode === "dark" ? "#362C20" : "#FFF9F2",
            color: "#FA9C2B",
          },
          "&.Mui-selected:hover": {
            backgroundColor: mode === "dark" ? "#362C20" : "#FFF9F2",
            color: "#FA9C2B",
          },
        },
      },
    },
  });
  useEffect(() => {
    if (!selectedProject) {
      setShowTagInput(false);
      resetOnAdd();
    }
  }, [selectedProject]);
  const [newTag, setNewTag] = useState({
    name: "",
    color: "",
  });
  const resetOnAdd = () => {
    setNewTag({
      name: "",
      color: "",
    });
    setError("");
    setShowTagInput(false);
  };

   useEffect(() => {
      const fetchFeatureLimitDetails = async () => {
        try {
          const { data } = await getSubscriptionLimit(featureCode);
          if (data?.code !== "RCI0000") return;
          console.log("Feature Limit Data:", data?.data?.currValue);
          setCurrentProjectsCount(data?.data?.currValue);
          setTotalProjectsCount(data?.data?.limit);
        } catch (error) {
          console.error("Error fetching project details:", error.message);
        } finally {
          setIsLimitLoading(false);
        }
      };
      fetchFeatureLimitDetails();
    }, []);

  const handleAddTag = () => {
    if (isCreatingTag) return;
    setIsCreatingTag(true);
    const payload = {
      name: newTag.name,
      iconUrl: newTag.color,
      projectId: selectedProject?.id
    };

    // const projectId = selectedProject?.id

    createTagWithProject(selectedProject?.id, payload).then((res) => {
      if (res.data.code === "RCI0022") {
        toast.success(t("RAL0197"));
        const newTagObject = {
          id: res.data.data.id,
          name: newTag.name,
          iconUrl: payload.iconUrl
        };
        const updatedProject = {
          ...selectedProject,
          tags: [...(selectedProject.tags || []), newTagObject]
        };

        setProjects(prevProjects =>
          prevProjects.map(p =>
            p.id === selectedProject.id ? updatedProject : p
          ));
        setSelectedProject(updatedProject);
        setSelectedTags(prev => [...prev, newTagObject]);
        resetOnAdd();
        return;
      }
      throw new Error(res.data.message);
    })
      .catch(error => {
        toast.error(error.message);
      })
      .finally(() => {
        setIsCreatingTag(false);
      });
  };
  const handleTaskCreated = (newTask) => {
    setIsCreatingTask(true);
    if (newTask.projectId === selectedProject?.id) {
      setTaskList(prevTasks => [...prevTasks, newTask]);
      setTaskId(newTask.id);
    }
    getTasksByProjectId(selectedProject.id).then((res) => {
      if (res.status === 200 && res.data?.code === "RCI0000") {
        const updatedTasks = res.data?.data?.tasks?.sort((o1, o2) => o1.taskId - o2.taskId) || [];
        const taskExists = updatedTasks?.some(t => t?.id === newTask?.id);
        setTaskList(updatedTasks);
        if (taskExists) {
          setTaskId(newTask.id);
          setError({ ...error, taskId: "" });
        } else{
           setTaskId(taskId);
        }
      }
    })
      .finally(() => {
        setIsCreatingTask(false);
      });
  };
  const handleCloseTaskPopup = () => {
    setIsTaskPopupOpen(false);
  };
  const handleAddChange = (e) => {
    const value = e.target.value;
    setNewTag({ ...newTag, name: value });
    setError("");
  };
  useEffect(() => {
    loadTags();
  }, []);

  const loadTags = () => {
    setTagData([]);
    const query = {
      pageNumber: 1,
      pageSize: 1000,
      toggleKeyToURL: true,
    };
    getTagByName(query).then((res) => {
      if (res?.data?.code === "RCI0000") {
        setTagData(res.data.data.tags);
      }
    });
  };

  const isValidForm = () => {
    if (!state.windowTitle) {
      setIsSubmit(false);
      return false;
    }
    if (!taskId) {
      setIsSubmit(false);
      return false;
    }

    if (!state.projectId) {
      setIsSubmit(false);
      return false;
    }

    if (!state.startTime) {
      setIsSubmit(false);
      return false;
    }
    if (!state.endTime) {
      setIsSubmit(false);
      return false;
    }
    setIsSubmit(true);
  };

  useEffect(() => {
    isValidForm();
  }, [state, taskId]);

  const durationInMilliseconds = state.endTime - state.startTime;
  const durationInSeconds = durationInMilliseconds / 1000;

  const userId = CommonUtil.getLoggedUser()?.id;
  const companyId = CommonUtil.getLoggedUser()?.companyId;

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      startTime: "",
      endTime: "",
    }));
  }, [selectedDate]);

  useEffect(() => {
    setZeroProjectCount(false)
    findProjectsByAssignedMember(CommonUtil.getLoggedUser()?.id)
      .then((res) => {
        if (res?.data && Array.isArray(res?.data?.data)) {
          const currentDate = new Date();
          currentDate.setHours(0, 0, 0, 0);
          const filteredProjects = res?.data?.data?.filter(
            (project) => project &&
              project.status !== "ARCHIVED" &&
              project.status !== "COMPLETED" &&
              new Date(project.startDate).setHours(0, 0, 0, 0) <= currentDate.getTime()
          );

          if (filteredProjects?.length > 0) {
            setProjects(filteredProjects);
          } else setZeroProjectCount(true);
        } else {
          setProjects([]);
          setZeroProjectCount(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching projects:", error);
      });
  }, []);

  useEffect(() => {
    if (totalEventsDurationInSec > 0) {
      setTotalEventsDuration(CommonUtil.getDuration(totalEventsDurationInSec));
    } else {
      setTotalEventsDuration(null);
    }
  }, [totalEventsDurationInSec]);

  useEffect(() => {
    if (state.projectId) {
      let project = projects?.filter((p) => p?.id === state.projectId);
      if (project.length > 0) {
        setSelectedProject(project[0]);
      }
    }
  }, [state.projectId, projects]);

  useEffect(() => {
    if (selectedProject && selectedProject?.id) {
      getTasksByProjectId(selectedProject?.id).then((res) => {
        if (res.status === 200 && res.data?.code === "RCI0000") {
          setTaskList(res.data?.data?.tasks?.sort((o1, o2) => o1.taskId - o2.taskId) || []);
        } else {
          setTaskList([]);
        }
      })
    }
  }, [selectedProject]);

  useEffect(() => {
    if (state.tags) {
      setSelectedTags(state.tags);
    }
  }, [state.tags]);

  useEffect(() => {
    if (totalEventsDuration) {
      setState((prevState) => ({
        ...prevState,
        hrs: totalEventsDuration?.hr,
        mins: totalEventsDuration?.min,
      }));
    }
  }, [totalEventsDuration]);

  const tagSelected = (event, value) => {
    setSelectedTags(value);
    setError((prevError) => ({ ...prevError, tags: "" }));
  };

  const validate = () => {
    const startTime = new Date(state.startTime);
    const endTime = new Date(state.endTime);
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const isToday = selectedDate.isSame(today, "day");
    const isStartTimeInThePast = startTime > now;
    const isEndTimeInvalid = endTime <= startTime;

    const startHours = startTime.getHours();
    const startMinutes = startTime.getMinutes();
    const endHours = endTime.getHours();
    const endMinutes = endTime.getMinutes();

    let hasError = false;

    setError({
      windowTitle: "",
      projectId: "",
      tags: "",
      description: "",
      duration: "",
      loggedDuration: "",
      eventDuration: "",
      events: "",
      startTime: "",
      endTime: "",
    });

    if (!state.windowTitle) {
      setError((prevError) => ({
        ...prevError,
        windowTitle: t("RAL0001"),
      }));
      hasError = true;
    }

    if (!state.projectId) {
      setError((prevError) => ({
        ...prevError,
        projectId: t("RAL0001"),
      }));
      hasError = true;
    }

    if (selectedTags.length > 20) {
      setError((prevError) => ({
        ...prevError,
        tags: t("RAL0687"),
      }));
      hasError = true;
    }

    if (!state.startTime) {
      setError((prevError) => ({
        ...prevError,
        startTime: t("RAL0001"),
      }));
      hasError = true;
    }

    if (!state.endTime) {
      setError((prevError) => ({
        ...prevError,
        endTime: t("RAL0001"),
      }));
      hasError = true;
    }

    if (isToday) {
      if (isStartTimeInThePast) {
        setError((prevError) => ({
          ...prevError,
          startTime: t("RAL0686"),
        }));
        setShowStartTimeError(true);
        hasError = true;
      } else {
        setShowStartTimeError(false);
      }

      if (endTime >= now) {
        setError((prevError) => ({
          ...prevError,
          endTime: t("RAL0685"),
        }));
        setShowTimeError(true);
        hasError = true;
      } else {
        setShowTimeError(false);
      }
    }

    if (isEndTimeInvalid) {
      setError((prevError) => ({
        ...prevError,
        endTime: t("RAL0688"),
      }));
      setShowEndTimeError(true);
      hasError = true;
    } else if (startHours === endHours && startMinutes === endMinutes) {
      setError((prevError) => ({
        ...prevError,
        endTime: t("RAL0747"),
      }));
      setShowEndTimeError(true);
      hasError = true;
    } else {
      setShowEndTimeError(false);
    }

    return !hasError;
  };

  useEffect(() => {
    if (showStartTimeError || showEndTimeError || showTimeError) {
      const timer = setTimeout(() => {
        setShowStartTimeError(false);
        setShowEndTimeError(false);
        setShowTimeError(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [showStartTimeError, showEndTimeError, showTimeError]);

  let eventTotalDuration = 0;

  const handleSubmit = async () => {
    if (validate()) {
      let payloadData = {
        ...state,
        tags: selectedTags.length > 0 ? selectedTags : [],
        userId: userId,
        companyId: companyId,
        duration: durationInSeconds,
        startTime: state.startTime.isUTC() ? state.startTime.format() : state.startTime.utc().format(),
        endTime: state.endTime.isUTC() ? state.endTime.format() : state.endTime.utc().format(),
      };

      // try {
      //   const manualEventsResponse = await addManualEvents(payloadData);
      //   if (manualEventsResponse.status === 200) {
      //     setSelectedEvents(manualEventsResponse.data?.data);
      //   } else {
      //     toast.error(manualEventsResponse.data?.message);
      //     return;
      //   }
      // } catch (error) {
      //   toast.error(t("RAL0689"));
      //   console.error("Error:", error);
      // }

      let payload = {
        ...state,
        title: state.windowTitle,
        tags: selectedTags,
        loggedDuration: durationInSeconds,
        eventDuration: eventTotalDuration,
        timesheetDate: state.startTime.isUTC() ? state.startTime.format() : state.startTime.utc().format(),
        eventDto: payloadData,
        taskId: taskId,
      };

      // Call createTimesheetManual API
      setIsLoading(true);
      createTimesheetManual(payload)
        .then((timesheetResponse) => {
          setIsLoading(false);
          if (timesheetResponse.status === 200) {
            if (timesheetResponse.data.code == "RCI0039") {
              toast.success(timesheetResponse.data?.message);
              setEventsToLog([]);
              setReload(true);
              onClose();
              setIsLogged(true);
            } else {
              toast.error(timesheetResponse.data?.message);
            }
          } else {
            toast.error(timesheetResponse.data?.message);
          }
        })
        .catch((error) => {
          toast.error(t("RAL0689"));
          console.error("Error:", error);
        });
    }
  };

  const handleFromTimeChange = (time) => {
    if (!dayjs(time).isValid()) {
      console.error("Invalid time object:", time);
      return;
    }
    // Set seconds and milliseconds to 0
    const adjustedTime = dayjs(selectedDate)
      .hour(time.hour())
      .minute(time.minute())
      .second(0)
      .millisecond(0);

    setState((prevState) => ({
      ...prevState,
      startTime: adjustedTime, // Keep the Day.js object for compatibility with TimePicker
    }));
  };

  const handleToTimeChange = (time) => {
    if (!dayjs(time).isValid()) {
      console.error("Invalid time object:", time);
      return;
    }

    // Set seconds and milliseconds to 0
    const adjustedTime = dayjs(selectedDate)
      .hour(time.hour())
      .minute(time.minute())
      .second(0)
      .millisecond(0);
    setState((prevState) => ({
      ...prevState,
      endTime: adjustedTime, // Keep the Day.js object for compatibility with TimePicker
    }));
    setIsDataChanged(true);
  };

  const handleCancel = () => {
    onClose();
  };

  useEffect(() => {
    if (textAreaRef.current) {
      const { scrollHeight } = textAreaRef.current;
      const height = Math.max(40, Math.min(scrollHeight, 200)); // Set a min and max height
      textAreaRef.current.style.height = `${height}px`; // Set the height dynamically
    }
  }, [state.description]);

  const textAreaRef = useRef(null);

  const handleDescriptionChange = (e) => {
    setState((prevState) => ({
      ...prevState,
      description: e.target.value,
    }));
    setError((prevError) => ({
      ...prevError,
      description: "",
    }));
  };

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = "auto";
      const { scrollHeight } = textAreaRef.current;
      const height = Math.max(40, Math.min(scrollHeight, 200));
      textAreaRef.current.style.height = `${height}px`;
    }
  }, [state.description]);

  const handleCancelButton = () => {
    const isPayloadEmpty = !(
      state.windowTitle !== "" ||
      state.projectId !== "" ||
      state.description !== "" ||
      state.startTime !== "" ||
      state.endTime !== "" ||
      state?.tags.length > 0 ||
      state.loggedDuration !== 0 ||
      state.eventDuration !== 0 ||
      state.events.length > 0 ||
      state.billable !== true ||
      state.hrs !== 0 ||
      state.mins !== 0
    );
    if (!isPayloadEmpty) {
      setIsCancelDialogOpen(true);
    } else {
      setEventsToLog([]);
      setReload(true);
      onClose();
    }
  };

  const handleCloseCancelDialog = () => {
    setIsCancelDialogOpen(false);
  };

  const handleConfirmCancel = () => {
    setIsCancelDialogOpen(false);
    onClose();
  };

  let role = CommonUtil.getLoggedUser()?.roleCode;
  const handleAddNewProject = () => {
    const projectCountFeature = subscriptionDetails?.features?.find(
      ({ feature }) => feature?.code === "PROJECT_COUNT"
    );

    if (isProjectLimitExceeded()) {
      if (!["OWNER"].includes(CommonUtil.getRoleCode())) {
        setRestrictPopupOpen(true);
      } else {
        setUpgradePopupOpen(true);
      }
    } else if (!subscriptionDetails || Object.keys(subscriptionDetails).length === 0) {
      if (!["OWNER"].includes(CommonUtil.getRoleCode())) {
        setRestrictPopupOpen(true);
      } else {
        setUpgradePopupOpen(true);
      }
    } else if (!projectCountFeature || projectCountFeature.value === undefined || projectCountFeature.value === null) {
      if (!["OWNER"].includes(CommonUtil.getRoleCode())) {
        setRestrictPopupOpen(true);
      } else {
        setUpgradePopupOpen(true);
      }
    }
    else {
      navigate("/projects/add", {
        state: { backto: window.location.pathname + "" },
      });
    }
  };
  const isProjectLimitExceeded = () => {

    if (!subscriptionDetails) return false;
    const isActive = ["live", "non_renewing"].includes(
      subscriptionDetails.status
    );
    const projectCountLimit = subscriptionDetails?.features?.find(
      ({ feature }) => feature?.code === "PROJECT_COUNT"
    )?.value;
    const currentProjectCount = projects?.length || 0;
    const limitExceeded =
      currentProjectCount >= Number(projectCountLimit) || false;
      const totalProjectLimitExceeded = currentProjectsCount >= Number(projectCountLimit) || false;
    if (!isActive) {
      if (!["OWNER"].includes(CommonUtil.getRoleCode())) {
        setRestrictPopupOpen(true);
        return true;
      } else {
        setUpgradePopupOpen(true);
        return true;
      }
    }

    if (limitExceeded || totalProjectLimitExceeded) {
      if (!["OWNER"].includes(CommonUtil.getRoleCode())) {
        setRestrictPopupOpen(true);
      } else {
        setUpgradePopupOpen(true);
      }
      return true;
    }
    return false;
  };
  const getPopupTitle = (subscriptionDetails, t, isRestrictPopup = false) => {
    if (CommonUtil.getStatusCondition(subscriptionDetails)) {
      return isRestrictPopup ? t("RAL0902") : t("RAL0853");
    } else if (CommonUtil.isPlanCodeDefault(subscriptionDetails)) {
      return t("RAL0850");
    } else {
      return t("RAL0852");
    }
  };

  const getPopupContent = (subscriptionDetails, t, isRestrictPopup = false) => {
    if (CommonUtil.getStatusCondition(subscriptionDetails)) {
      return isRestrictPopup ? t("RAL0903") : t("RAL0854");
    } else if (CommonUtil.isPlanCodeDefault(subscriptionDetails)) {
      return t("RAL0849");
    } else {
      return t("RAL0851");
    }
  };
  const typographyStyle = {
    color: mode == "dark" ? "#F8F8F8" : "#242424",
    fontFamily: "Gotham",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width: "100%",
    opacity: "0.8",
    fontSize: "14px",
    lineHeight: "21px",
    padding: "2px 12px",
    cursor: "pointer",
  }
  return (
    <div
      className={css`
        min-height: calc(100% - 20px);
        position: relative;
        background: var(--background-color-14);
        // padding: 0px 20px 20px 20px;
        padding: 0px 14px 0px 14px;
        margin-top: 18px;
        height: 78vh;
        @media (min-width: 1600px) {
          // height: 70vh;
        }
      `}
    >
      {zeroProjectCount ? <>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "70vh",
            flexDirection: "column",
          }}
        >
          <div>
            {mode == "dark" ? (
              <EmptyProjectListDark
                style={{ width: "60px", height: "70px" }}
              />
            ) : (
              <EmptyProjectList style={{ width: "60px", height: "70px" }} />
            )}
          </div>
          <Typography className="cardtile-typography111">
            {t("RAL0732")}
          </Typography>
          {CommonUtil.isOwnerOrAdminOrManager() ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <Typography
                className="cardtile-typography11"
                width={"90%"}
                textAlign={"center"}
              >
                {t("RAL0823")}
              </Typography>
              <Box
                sx={{
                  height: { xl: "50px", xs: "40px" },
                  width: { xl: "150px", xs: "130px" },
                  alignSelf: "center",
                }}
              >
                <CustomButton
                  id="btn-add-event"
                  variant="contained"
                  fullWidth={true}
                  onClick={handleAddNewProject}
                >
                  {t("RAL0361")}
                  {/* {"+"} */}
                </CustomButton>
              </Box>
            </div>
          ) : (
            <Typography className="cardtile-typography">
              {t("RAL0822")}
            </Typography>
          )}
        </Box>
      </> : <>
        <Box
          item
          className={`${css`
          background: var(--background-color-14);
          padding-bottom: 20px;
          padding-top: 20px;
          align-items: center;
          display: flex;
          position: sticky;
          top: 0;
          z-index: 9;
        `} `}
        >
          <Box flexGrow={1}>
            <Typography
              variant="header3"
              sx={{
                color: "var( --text-secondary-80)",
                font: "normal normal bold 16px/19px Gotham",
                letterSpacing: "0px",
              }}
            >
              {t("RAL0337")}
            </Typography>
          </Box>
        </Box>

        <Box
          className={css`
          height: calc(82% - 20px);
          overflow: hidden;
          padding-right: 0px;
          :hover {
            overflow-y: auto;
            padding-right: 0px;
          }
        `}
        >
          <Box display={"flex"} flexDirection={"column"} mb={2} rowGap={2}>
            <Box item width={"100%"}>
              <CustomTextField
                id="text-title-addevnt"
                hideLabel={true}
                onChange={(e) => {
                  setState((prevState) => ({
                    ...prevState,
                    windowTitle: e.target.value,
                  }));
                  setError((prevError) => ({
                    ...prevError,
                    windowTitle: "",
                  }));
                }}
                placeholder={t("RAL0338")}
                required
                helperText={error?.windowTitle}
                error={Boolean(error?.windowTitle)}
                label={t("RAL0572")}
                value={state.windowTitle}
                sx={{
                  ".MuiInputBase-input.MuiOutlinedInput-input": {
                    padding: "13px !important",
                  },
                  "& .MuiOutlinedInput-root ": {
                    backgroundColor: "var(--background-color-3) !important",
                    // color: "var(--text-primary)",
                    // "&.Mui-focused": {
                    //   backgroundColor: "var(--input-focused-background-15) !important",
                    // },
                    // "&.Mui-error ": {
                    //   backgroundColor: "var(--input-error-background) !important",
                    // },
                    // "&.Mui-focused fieldset": {
                    //   backgroundColor: "var(--input-focused-background-15) !important",
                    // },
                  },
                }}
              // inputProps={{
              //   maxLength: 50,
              // }}
              />
            </Box>

            <Box item width={"100%"} mt={1}>
              <CustomTextField
                id="text-description-addevnt"
                hideLabel={true}
                multiline
                rows={1}
                inputRef={textAreaRef}
                onChange={handleDescriptionChange}
                placeholder={t("RAL0292")}
                required
                helperText={error?.description}
                error={Boolean(error?.description)}
                label={t("RAL0292")}
                value={state.description}
                sx={{
                  ".MuiInputBase-input.MuiOutlinedInput-input": {
                    padding: "0px !important",
                  },
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "var(--background-color-3) !important",
                    overflow: "hidden",
                  },
                }}
                inputProps={{
                  maxLength: 2000,
                }}
              />
              <Box display={"flex"} flexDirection={"row-reverse"}>
                <Typography
                  variant="activity_log_count"
                  sx={{
                    color: "var(--text-secondary-80-80)",
                  }}
                >
                  {state?.description?.length}/2000
                </Typography>
              </Box>
            </Box>

            <Box item width={"100%"} mt={-1}>

              <Autocomplete
                error={Boolean(error.projectId)}
                helperText={error.projectId}
                id="dropdown-member-create-team lead"
                fullWidth
                size={"small"}
                getOptionLabel={(option) => option?.name || ""}
                clearText={t('RAL0693')}
                value={selectedProject}
                options={projects ? projects : []}
                noOptionsText={t("RAL0732")}
                renderInput={(params) => (
                  <CustomTextField
                    hideLabel={true}
                    dropdown={true}
                    placeholder={t("RAL0288")}
                    required
                    helperText={error?.projectId}
                    error={Boolean(error?.projectId)}
                    {...params}
                    label={t("RAL0288") + " *"}
                    sx={{
                      "& .MuiOutlinedInput-root ": {
                        backgroundColor: "var(--background-color-3) !important",
                        // color: "var(--text-primary)",
                        // "&.Mui-focused": {
                        //   backgroundColor: "var(--input-focused-background-15) !important",
                        // },
                        // "&.Mui-error ": {
                        //   backgroundColor: "var(--input-error-background) !important",
                        // },
                        // "&.Mui-focused fieldset": {
                        //   backgroundColor: "var(--input-focused-background-15) !important",
                        // },
                      },
                    }}


                  />
                )}
                renderOption={(props, option) => (
                  <Box  {...props}>
                    <CustomTypography title={option.name}
                      component={{
                        typography: {
                          sx: typographyStyle
                        }
                      }}
                    >{option.name}</CustomTypography>
                  </Box>
                )}
                onChange={(event, newValue) => {
                  setSelectedProject(newValue);
                  setState((prevState) => ({
                    ...prevState,
                    projectId: newValue ? newValue.id : "",
                    tags: [],
                  }));
                  setSelectedTags([]);
                  setTaskId("");
                  setError((prevError) => ({
                    ...prevError,
                    projectId: "",
                    taskId: "",
                  }));
                }}
                componentsProps={commonComponentsProps(mode)}
                sx={{
                  ".MuiInputBase-input.MuiOutlinedInput-input": {
                    paddingX: "10px !important",
                  },
                }}
              />
            </Box>
            {/* {(isCreatingTag || isCreatingTask) && (
              <Box
                sx={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 9999,
                }}
              >
                <CircularProgress />
              </Box>
            )} */}
            <Box item width={"100%"}>
              <Autocomplete
                disabled={!selectedProject}
                size="small"
                fullWidth
                id="task-outlined"
                options={taskList ? taskList : []}
                getOptionLabel={(option) => option?.taskId + " " + option?.title || ""}
                noOptionsText={t("RAL1164")}
                value={taskList.find((task) => task.id === taskId) || null}
                onChange={(e, newTask) => {
                  if (newTask !== null) {
                    setTaskId(newTask.id)
                  } else {
                    setTaskId("");
                  }
                  setError({ ...error, taskId: "" });
                }}
                error={!CommonUtil.isEmptyString(error.taskId)}
                helperText={error.taskId}
                componentsProps={commonComponentsProps(mode)}
                sx={{
                  ".MuiInputBase-input.MuiOutlinedInput-input": {
                    paddingX: "10px !important",
                  },
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => {
                  const selectedTask = taskList.find((task) => task.id === taskId);
                  const taskLabel = selectedTask ? `${selectedTask.taskId} ${selectedTask.title}` : "";

                  return (
                    <Tooltip
                      title={taskLabel}
                      disableHoverListener={!taskLabel || taskLabel.length < 22}
                    >
                      <div>
                        <CustomTextField
                          dropdown={true}
                          hideLabel={true}
                          onChange={(e) => { }}
                          required
                          helperText={error?.taskId}
                          error={error?.taskId}
                          value={taskId}
                          {...params}
                          label={t("RAL1123") + " *"}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: "var(--background-color-3) !important",
                            },
                            "& .MuiInputBase-input": {
                              textOverflow: "ellipsis",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                            },
                          }}
                        />
                      </div>
                    </Tooltip>
                  );
                }}
                renderOption={(props, option) => (
                  <Box  {...props}>
                    <Chip
                      id="tags-outlined"
                      key={option.id}
                      label={option.taskId}
                    />
                    <CustomTypography title={option.title}
                      component={{
                        typography: {
                          sx: typographyStyle
                        }
                      }}
                    >{option.title}</CustomTypography>
                  </Box>
                )}

              />
            </Box>

            {selectedProject && (
              <span
                className={mode === "dark" ? "worklog-add-tag-dark" : "worklog-add-tag"}
                onClick={() => setIsTaskPopupOpen(true)}
              >
                {t("RAL1124")}
              </span>
            )}

            <Box item width={"100%"} mt={1.5}>
              <Autocomplete
                disabled={!selectedProject}
                multiple
                disableCloseOnSelect={true}
                id="btn-text-tag-addevent"
                options={selectedProject ? selectedProject?.tags : []}
                getOptionLabel={(option) => option.name}
                filterSelectedOptions
                noOptionsText={t("RAL0720")}
                ChipProps={{
                  sx: {
                    backgroundColor: "var(--popover-background) !important",
                    color: "var(--text-secondary-80)",
                    borderRadius: "2px",

                    "& .MuiChip-deleteIcon": {
                      color: "var(--text-secondary-50)",
                    },
                  },
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      key={option.id}
                      label={option.name}
                      icon={
                        option.iconUrl ? (
                          <img
                            src={option.iconUrl}
                            alt={option.name}
                            height={18}
                            width={18}
                          />
                        ) : (
                          <TagInactiveIcon height={17.99} width={17.99} />
                        )
                      } // Dynamically set the icon
                      {...getTagProps({ index })}
                      deleteIcon={<CancelIcon />}
                    />
                  ))
                }
                value={selectedTags}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={tagSelected}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    sx={{ "& > span": { mr: 2, flexShrink: 0 } }}
                    {...props}
                    key={option.id}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        height: "auto",
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                        display: "inline",
                      }}
                    >
                      <Box display={"flex"} columnGap={1} alignItems={"center"}>
                        {option?.iconUrl ? (
                          <img
                            src={option?.iconUrl}
                            alt={option.name}
                            height={17.99}
                            width={17.99}
                          />
                        ) : (
                          <TagInactiveIcon height={17.99} width={17.99} />
                        )}

                        <Box>{option.name}</Box>
                      </Box>
                    </Box>
                  </Box>
                )}
                componentsProps={commonComponentsProps(mode)}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    background: tagError
                      ? "#FFF1F1 0% 0% no-repeat padding-box"
                      : "#F4F5F8 0% 0% no-repeat padding-box",
                    "& fieldset": {
                      borderRadius: "none",
                      border: "none",
                    },
                    ".MuiInputBase-input.MuiOutlinedInput-input": {
                      paddingY: "4px !important",
                      paddingX: "5px !important",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "none",
                    },
                    "&:hover fieldset": {
                      borderColor: "none",
                    },
                    "& .MuiInputLabel-root ": {
                      display: "none",
                      border: "none",
                    },
                  },
                  "& .MuiAutocomplete-clearIndicator": {
                    borderRadius: 0,
                    position: "relative",
                    right: "20px",
                  },
                  "& .MuiChip-root": {
                    // background: "#FFFFFF 0% 0% no-repeat padding-box",
                    borderRadius: "2px",
                  },
                }}
                renderInput={(params) => (
                  <CustomTextField
                    dropdown={true}
                    hideLabel={true}
                    helperText={error?.tags}
                    error={Boolean(error?.tags)}
                    {...params}
                    label={t("RAL0191")}
                    inputProps={{
                      ...params.inputProps,
                      maxLength: 20
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root ": {
                        backgroundColor: "var(--background-color-3) !important",
                        // color: "var(--text-primary)",
                        // "&.Mui-focused": {
                        //   backgroundColor: "var(--input-focused-background-15) !important",
                        // },
                        // "&.Mui-error ": {
                        //   backgroundColor: "var(--input-error-background) !important",
                        // },
                        // "&.Mui-focused fieldset": {
                        //   backgroundColor: "var(--input-focused-background-15) !important",
                        // },
                      },
                    }}
                  />
                )}
              />
            </Box>
            {CommonUtil.isOwnerOrAdminOrManager() && selectedProject && (
              <span
                className={mode === "dark" ? "worklog-add-tag-dark" : "worklog-add-tag"}
                onClick={() => setShowTagInput(true)}
                style={{ display: showTagInput ? 'none' : 'block' }}
              >
                {t("RAL1196")}
              </span>
            )}
            {
              showTagInput && selectedProject && (
                <div>
                  <Box className="project-tags-add-wra45435pper">
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      className="new-tag1"
                      justifyContent={"center"}
                      flexDirection={"row-reverse"}
                    >
                      <Box
                        display={"flex"}
                        flexGrow={1}
                        alignItems={"center"}
                      // className="tag-name"
                      >
                        <Box item flexGrow={1}>
                          <TagworkField
                            id="textfield-tags-add"
                            label={t("RAL0194")}
                            error={!!error}
                            helperText={error}
                            value={newTag.name}
                            onChange={(e) => handleAddChange(e)}
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') {
                                handleAddTag();
                              }
                            }}
                            onClick={handleAddTag}
                            onCancelClick={resetOnAdd}
                            inputProps={{
                              maxLength: 20,
                            }}
                            disabled={isCreatingTag}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                </div>
              )}

            <Box className="durationTime">
              <Box display="flex" mt={1} columnGap={0.6}>
                <Box item width={"50%"}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div className="custom-time-picker">
                      <TimePicker
                        id="btn-strttime-picker-add-evnt"
                        allowClear={false}
                        label={t("RAL0339")}
                        placeholder={t("RAL0339") + "*"}
                        name="startTime"
                        value={state.startTime}
                        format="HH:mm"
                        onChange={handleFromTimeChange}
                        error={Boolean(error?.startTime)}
                        helperText={error.startTime}
                        locale={{
                          lang: {
                            locale: dayjs.locale(),
                            now: t("RAL0727"),
                          },
                        }}
                        // status={!!error.startTime ? "error" : ""}
                        style={{
                          width: "100%",
                          height: "50px",
                          backgroundColor: "var(--background-color-3)",
                          color: "var(--text-secondary-50)",
                          border: "none",
                          boxShadow: "none",
                        }}
                        needConfirm={false}
                        slotProps={{ textField: { size: "medium" } }}
                        renderInput={(props) => <CustomTextField {...props} />}
                      />
                    </div>
                  </LocalizationProvider>
                </Box>

                <Box item width={"50%"} className="custom-time-picker">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      id="btn-endtime-picker-add-evnt"
                      allowClear={false}
                      label={t("RAL0340")}
                      placeholder={t("RAL0340") + "*"}
                      name="endTime"
                      format="HH:mm"
                      value={state.endTime}
                      onChange={handleToTimeChange}
                      error={Boolean(error?.endTime)}
                      helperText={error.endTime}
                      locale={{
                        lang: {
                          locale: dayjs.locale(),
                          now: t("RAL0727"),
                        },
                      }}
                      // showNow={false}
                      // status={!!error.endTime ? "error" : ""}
                      style={{
                        width: "100%",
                        height: "50px",
                        backgroundColor: "var(--background-color-3)",
                        color: "var(--text-secondary-50)",
                        border: "none",
                        boxShadow: "none",
                      }}
                      needConfirm={false}
                      slotProps={{ textField: { size: "medium" } }}
                      minTime={state.startTime}
                      renderInput={(props) => <CustomTextField {...props} />}
                    />
                  </LocalizationProvider>
                </Box>
              </Box>

              {((showEndTimeError && error.endTime) ||
                (showTimeError && error.endTime)) && (
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    pt={0.5}
                    sx={{
                      flexDirection: { xs: "column", sm: "row" },
                      alignItems: { xs: "flex-start", sm: "center" },
                    }}
                  >
                    <Box pr={1} display="flex" alignItems="center">
                      {<ErrorIcon />}
                    </Box>
                    <Box display="flex" alignItems="center">
                      <Typography
                        className="helper-text"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {error.endTime}
                      </Typography>
                    </Box>
                  </Box>
                )}

              {showStartTimeError && error.startTime && (
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  pt={0.5}
                  sx={{
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: { xs: "flex-start", sm: "center" },
                  }}
                >
                  <Box pr={1} display="flex" alignItems="center">
                    {<ErrorIcon />}
                  </Box>
                  <Box display="flex" alignItems="center">
                    <Typography
                      className="helper-text"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {error.startTime}
                    </Typography>
                  </Box>
                </Box>
              )}
            </Box>

            <Box
              className={css`
              background: var(--background-color-3) 0% 0% no-repeat padding-box;
              border-radius: 5px;
              opacity: 1;
              display: flex;
              padding: 12px;
              align-items: center;
            `}
            >
              <Box item flexGrow={1}>
                <Typography className="billabeTextAddEvent">
                  {t("RAL0341")}
                </Typography>
              </Box>
              <Box item>
                <CustomSwitch
                  checked={state.billable}
                  onChange={(e) =>
                    setState({ ...state, billable: e.target.checked })
                  }
                />
              </Box>
            </Box>
          </Box>

          <Box
            className="btnFixedScrollAI"
            display={"flex"}
            flexDirection={"row-reverse"}
            pt={2}
          >
            <Box item pl={1} width={"50%"}>
              <CustomButton
                id="btn-log-evnt"
                variant="contained"
                size="large"
                fullWidth="fullWidth"
                onClick={handleSubmit}
                disabled={!isSubmit}
              >
                <span>{t("RAL0342")}</span>
              </CustomButton>
            </Box>

            <Box item width={"50%"} pr={1}>
              <CustomButton
                id="btn-cancel-evnt"
                variant="outlined"
                size="large"
                fullWidth="fullWidth"
                onClick={handleCancelButton}
              >
                <span>{t("RAL0177")}</span>
              </CustomButton>
            </Box>
          </Box>
        </Box>
      </>}

      <CancelDialog
        open={isCancelDialogOpen}
        onClose={handleCloseCancelDialog}
        onConfirm={handleConfirmCancel}
        header={t("RAL0393")}
        message={t("RAL0394")}
      />
      {
        isTaskPopupOpen && (
          <TaskPopup
            open={isTaskPopupOpen}
            onClose={handleCloseTaskPopup}
            onTaskCreated={handleTaskCreated}
            selectedProject={selectedProject}
            isLoading={isCreatingTask}
          />
        )
      }

      <Box
        sx={{
          display: isLoading ? "flex" : "none",
          zIndex: 999,
        }}
      >
        <CircularProgress
          style={{ top: "50%", left: "85%", position: "fixed" }}
        />
      </Box>
      {["OWNER"].includes(CommonUtil.getRoleCode()) && (
        <UpgradePopup
          open={upgradePopupOpen}
          onClose={() => setUpgradePopupOpen(false)}
          onConfirm={() => {
            if (CommonUtil.getRoleCode() === "OWNER") {
              navigate("/subscription-manage");
            } else {
              navigate("/page-not-found");
            }
          }}
          title={getPopupTitle(subscriptionDetails, t)}
          content={getPopupContent(subscriptionDetails, t)}
          cancelText={t("RAL0177")}
          confirmText={t("RAL0848")}
        />
      )}

      {!["OWNER"].includes(CommonUtil.getRoleCode()) && (
        <RestrictPermissionPopup
          open={restrictPopupOpen}
          onClose={() => setRestrictPopupOpen(false)}
          title={getPopupTitle(subscriptionDetails, t, true)}
          content={getPopupContent(subscriptionDetails, t, true)}
          cancelText={t("RAL0177")}
        />
      )}
    </div>
  );
}
